var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommunicationCards',{attrs:{"data":_vm.userCommunication,"title":'User'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }